import { render, staticRenderFns } from "./SMSOnboardingStepBrand.vue?vue&type=template&id=2b0b4da0&scoped=true"
import script from "./SMSOnboardingStepBrand.vue?vue&type=script&lang=js"
export * from "./SMSOnboardingStepBrand.vue?vue&type=script&lang=js"
import style0 from "./SMSOnboardingStepBrand.vue?vue&type=style&index=0&id=2b0b4da0&prod&lang=scss&scoped=true"
import style1 from "./SMSOnboardingStepBrand.vue?vue&type=style&index=1&id=2b0b4da0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0b4da0",
  null
  
)

export default component.exports